import React from 'react';
import styles from './IntroCopy.module.scss';
import { Body } from 'components/text';

const IntroCopy: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.copy}>
        <Body className={styles.introText}>
          Whether it's a special occasion, a token of appreciation or a 'just
          because' treat, Little Emperors e-gift cards let you share a world of
          unforgettable hotels with the people you care about.
        </Body>
        <Body className={styles.introText}>
          And the cherry on top? New members who join with a gift card get
          <br className="hideTablet" />{' '}
          <b>6 months of Travel membership on us</b>, so they can immediately
          unlock access to the best rates and most benefits at more than 5,000
          luxury hotels.
        </Body>
      </div>
    </div>
  );
};

export default IntroCopy;
